import { gql } from '@apollo/client';

export const CREDIT_SUBMISSION_DECISION_FRAGMENT = gql`
  fragment CreditSubmissionDecisionFields on CreditSubmissionDecisionViewModel {
    id
    creditSubmissionId
    createdDateTime
    modifiedDateTime
    interestRate
    termRates {
      term
      rate
    }
    minDownPayment
    daysToFirstPayment
    numAdvancePayments
    maxApprovalAmount
    rateConfiguration
    rateType
    customerRate
    residualPercentage
    financeProgramId
    financeProgramType
    startDate
    markups {
      identifier
      markupFlat
      markupPercentage
    }
    subsidyCapConfiguration {
      lenderName
      subsidyCapType
      maxSubsidyAmount
      netInvoiceAmount
      netInvoicePercentage
      paymentAmountSubsidized
      paymentAmountSubsidizedAtLenderMarketRate
      lenderMarketRates {
        term
        rate
      }
    }
    fees {
      fee
      type
      financed
      identifier
    }
    createdBy {
      id
      fullName
    }
  }
`;
